import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button, Collapse, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Icon from '@material-ui/core/Icon';
import InputFeild from "../../global/form/input";
import ImageUploadFeild from "../../global/form/upload-image";
import { setError, setLoader, setSuccess } from "../../../actions/action-creators";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import moment from "moment";
import ConfirmAction from "../../global/confirm-action";
import SelectList from "../../global/form/select";
import VideoUploadFeild from "../../global/form/upload-video";
import { Chip } from "@material-ui/core";
import CONSTANTS from "../../../constants";







class ManageAppVideos extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isAddSection: false,
          videoSectionsList: [],
          isAddVideo: false,
          isOpenConfirm: false,
          draggedSectionIndex: null,
          draggedVideoIndex: null
        }
    }

        handleDragSection = (e) => {
            this.setState({draggedSectionIndex: e.currentTarget.id});
        }
    
        handleDropSection = async (e) => {
            let { draggedSectionIndex } = this.state;
            let droppedSectionIndex = e.currentTarget.id;
            if(!draggedSectionIndex || !droppedSectionIndex) return; 

            let sections = [...this.state.videoSectionsList];

            let draggedSection = sections.splice(draggedSectionIndex, 1);

            if(!draggedSection[0]) return;

            sections.splice(droppedSectionIndex, 0, draggedSection[0])
            
            sections = sections.map((section, i) => {
                section.order_index = i + 1;
                return section;
            });
            let updateData = sections.filter((section, i) => draggedSectionIndex > droppedSectionIndex ?  i >= droppedSectionIndex : i >= draggedSectionIndex && i <= droppedSectionIndex).map(section => ({video_section_id: section.video_section_id, order_index: section.order_index}));
            await Promise.all(updateData.map(async section => {
                await ApiEndpoints.Videos.editSection(section)
            }));
            this.setState({ videoSectionsList: [...sections] })
        }
          
        
        handleDragVideo = (e) => {
            this.setState({draggedVideoIndex: e.currentTarget.id});
        }
    
        handleDropVideo = async (e, videoSectionId, videos) => {
            let { videoSectionsList } = this.state;
            
            let { draggedVideoIndex } = this.state;
            let droppedVideoIndex = e.currentTarget.id;

            if(!draggedVideoIndex || !droppedVideoIndex) return; 

            let draggedVideo = videos.splice(draggedVideoIndex, 1);

            if(!draggedVideo[0]) return;

            videos.splice(droppedVideoIndex, 0, draggedVideo[0])
            
            videos = videos.map((section, i) => {
                section.order_index = i + 1;
                return section;
            });
            let updateData = videos.filter((video, i) => draggedVideoIndex > droppedVideoIndex ?  i >= droppedVideoIndex : i >= draggedVideoIndex && i <= droppedVideoIndex).map(video => ({video_id: video.video_id, order_index: video.order_index}));
            await Promise.all(updateData.map(async section => {
                await ApiEndpoints.Videos.editVideo(section)
            }));

            videoSectionsList = videoSectionsList.map(section => {
                if(section.video_section_id === videoSectionId) section.Videos = [...videos];
                return section;
            })

            this.setState({ videoSectionsList })
        }
        
    
    componentDidMount(){
        this.videoSectionsList();
    }

    videoSectionsList = async() => {
        store.dispatch(setLoader(true))
        try{
            let apiData = await ApiEndpoints.Videos.fetchVideoSections();
            let videoSectionsList = apiData.data.data;
            this.setState({ videoSectionsList })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false));

    }


    previewVideo = (videoUrl) => {
        window.open(videoUrl, "_blank")
    }
    
    addVideoSection = async (e) => {
        e.preventDefault();
        let { isAddSection } = this.state;

        let sectionData = {
            title: isAddSection.title,
            description: isAddSection.description || "",
            entity_type:  isAddSection.entity_type,
        };
        store.dispatch(setLoader(true));
        if(isAddSection.video_section_id) {
            sectionData.video_section_id = isAddSection.video_section_id
            await ApiEndpoints.Videos.editSection(sectionData);
        }
        else await ApiEndpoints.Videos.addSection(sectionData);
        await this.videoSectionsList();
        await this.setState({isAddSection:false})
        store.dispatch(setLoader(false));
    }

    expendSection = async (videoSectionId, isExpended) => {
        let { videoSectionsList } = this.state;
        let sectionVideos = null;
        if(isExpended){
            try{
                let videoResp = await ApiEndpoints.Videos.fetchVideos({video_section_id: videoSectionId});
                sectionVideos = videoResp.data.data;
            }
            catch(e){
                console.log(e)
            }
        }
        videoSectionsList = videoSectionsList.map(section => {
            if(videoSectionId){
                if(videoSectionId === section.video_section_id) {
                    section.isExpended = isExpended;
                    if(sectionVideos) section.Videos = sectionVideos;
                }
            }
            else section.isExpended = isExpended;
            return section
        });
        this.setState({ videoSectionsList })
    }
        

    formatDuration = (seconds) => {
        if (!seconds) return null;
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s.toString().padStart(2, "0")}`;
    }

    getVideoFileMeta = (e) => {
        let { isAddVideo } = this.state;
        // let checkSize = e.target.duration * 204.8; //per second 200kb (1024/10)
        // var fileSize = isAddMediaContent.file.size/1024;

        // if(fileSize > checkSize){
        //     isAddMediaContent.file = null;
        //     this.setState({ isAddMediaContent });
        //     return store.dispatch(setError({show: true, message: `Video size must be below ${checkSize}KB (200kb/second)`}));
        // }
        isAddVideo.duration = e.target.duration;
        this.setState({ isAddVideo });
    }


    addVideo = async () => {
        let { isAddVideo, videoSectionsList } = this.state;
        const isNewVideo = !isAddVideo.video_id;
        const isEditTranslation = !!(isAddVideo.video_id && isAddVideo.video_translation_id);
        const isAddTranslation = !!(isAddVideo.video_id && !isAddVideo.video_translation_id);

        store.dispatch(setLoader(true));
        try {
            // upload files
            const uploadFile = async (file, entityType, entityId) => {
                let fileName = `training_video/${entityType || "GENERIC"}`;
                if (entityId) fileName += `/${entityId}`;
                fileName += `/${new Date().getTime()}_${file.name}`;
                let fileResp = await ApiEndpoints.Files.filePublicPutUrl({ file_name: fileName });
                let file_url = fileResp.data.data.url;
                if (!file_url) throw new Error("Unable to upload file. Please try again later.");
                await ApiEndpoints.Files.uploadFileToS3(file_url, file, { headers: { "Content-Type": file.type } });
                return fileResp.data.data.fileUrl;
            };

            var contentBody = {
                lang: isAddVideo.lang || "en",
                title: isAddVideo.title,
                description: isAddVideo.description,
                duration: isAddVideo.duration,
            };

            if (isAddVideo.thumbnail_file) {
                contentBody.thumbnail_url = await uploadFile(isAddVideo.thumbnail_file, isAddVideo.entity_type, isAddVideo.entity_id);
            }
            if (isAddVideo.video_file) {
                contentBody.video_url = await uploadFile(isAddVideo.video_file, isAddVideo.entity_type, isAddVideo.entity_id);
            }

            if (isNewVideo) {
                // case 1: add initial video (lang = en fixed)
                let selectedVideoSection = videoSectionsList.find(s => s.video_section_id === isAddVideo.video_section_id);
                let maxOrder = selectedVideoSection.Videos.length ? Math.max(...selectedVideoSection.Videos.map(v => v.order_index)) : -1;
                contentBody.video_section_id = isAddVideo.video_section_id;
                contentBody.entity_type = isAddVideo.entity_type || "GENERIC";
                contentBody.entity_id = isAddVideo.entity_id || 0;
                contentBody.order_index = maxOrder + 1;
                contentBody.lang = "en";
                await ApiEndpoints.Videos.addVideo(contentBody);

            } else if (isEditTranslation) {
                // case 2: edit existing translation
                contentBody.video_id = isAddVideo.video_id;
                contentBody.video_translation_id = isAddVideo.video_translation_id;
                await ApiEndpoints.Videos.editVideo(contentBody);

            } else if (isAddTranslation) {
                // case 3: add new translation to existing video
                contentBody.video_id = isAddVideo.video_id;
                await ApiEndpoints.Videos.addTranslation(contentBody);
            }

            this.setState({ isAddVideo: false });
            this.expendSection(isAddVideo.video_section_id, true); // refresh videos
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    setIsEditSection = (section) => {
        this.setState({ isAddSection: section })
    }

    deleteVideo = async (video, translation) => {
        let { videoSectionsList } = this.state;
        const isTranslationOnly = translation && video.VideoTranslations && video.VideoTranslations.length > 1;
        store.dispatch(setLoader(true))
        try{
            if (isTranslationOnly) {
                await ApiEndpoints.Videos.deleteTranslation({ video_translation_id: translation.video_translation_id });
                videoSectionsList = videoSectionsList.map(section => ({
                    ...section,
                    Videos: (section.Videos || []).map(v => v.video_id === video.video_id
                        ? { ...v, VideoTranslations: v.VideoTranslations.filter(t => t.video_translation_id !== translation.video_translation_id), selectedLang: "en" }
                        : v
                    )
                }));
            } else {
                await ApiEndpoints.Videos.deleteVideo({ video_id: video.video_id });
                videoSectionsList = videoSectionsList.map(section=> {
                    if(section.video_section_id === video.video_section_id){
                        section.Videos = section.Videos.filter(v => v.video_id !== video.video_id);
                    }
                    return section;
                });
            }
            this.setState({ videoSectionsList })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }


    render() {
        let { isAddSection, videoSectionsList, isAddVideo } = this.state;
        let jobList = store.getState().jobList

        return (
            <>
                <Button id="add_section" onClick={() => this.setState({isAddSection : isAddSection ? false : {}})} type="button" className="buttonred" size="xs" style={{ height: "27px", paddingTop: "3px"}}>Add New Section</Button>

               

                <div className="mt-3">

                {
                    videoSectionsList.map((section, i) => {
                        return (
                        <div className="mb-3 shadow-sm" style={{borderRadius: 10, overflow: "hidden", border: "1px solid #e0e0e0"}}>
                            <div className="px-3 py-2" style={{background: "#f5f5f5", borderBottom: section.isExpended ? "1px solid #e0e0e0" : "none"}}  id={i} draggable={true} onDragOver={(ev) => ev.preventDefault()} onDragStart={this.handleDragSection} onDrop={this.handleDropSection} >
                                <Row className="align-items-center">
                                    <Col xs={8}>
                                        <span className="d-block font-weight-bold">{section.title}</span>
                                        <span className="small">{section.description}</span>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                        <Icon className="align-middle mr-3" onClick={() => this.setIsEditSection({...section, Videos: []} )}>edit</Icon>
                                        <Icon className="align-middle mr-3 clickable" title="Add Video" onClick={() => this.setState({ isAddVideo: { video_section_id: section.video_section_id } })}>add</Icon>
                                        <Icon className="align-middle mr-3 clickable">reorder</Icon>
                                        <Icon style={{fontSize: 20, cursor: "pointer"}} className="align-middle clickable" onClick={() => this.expendSection(section.video_section_id, !section.isExpended)}>unfold_more</Icon>
                                    </Col>
                                </Row>
                            </div>
                            {!!section.isExpended &&
                            <div style={{background: "#fafafa", padding: "14px 16px 6px 16px"}}>
                                <div style={{display: "flex", flexWrap: "nowrap", overflowX: "auto", gap: 12, paddingBottom: 8}}>
                                    {
                                        (section.Videos || []).map((video, videoIndex) => {
                                            const displayTranslation = (video.VideoTranslations || []).find(t => t.lang === (video.selectedLang || "en")) || (video.VideoTranslations || [])[0] || {};
                                            return (
                                                <div key={video.video_id} className="visible-on-hover-container" id={videoIndex} draggable={true} onDragOver={(ev) => ev.preventDefault()} onDragStart={this.handleDragVideo} onDrop={(e) => this.handleDropVideo(e, section.video_section_id, section.Videos)}
                                                    style={{minWidth: 160, maxWidth: 160, flexShrink: 0, marginBottom: 8}}>
                                                    <div className="shadow-sm h-100" style={{borderRadius: 10, background: "#fff", overflow: "hidden", display: "flex", flexDirection: "column", border: "1px solid #ececec"}}>
                                                        {/* Thumbnail with play overlay */}
                                                        <div className="clickable" style={{position: "relative", aspectRatio: "700/1152", background: "#000", overflow: "hidden"}} onClick={() => this.previewVideo(displayTranslation.video_url)}>
                                                            <img style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover"}} src={displayTranslation.thumbnail_url} alt="thumbnail" />
                                                            <div className="visible-on-hover-item" style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.35)"}}>
                                                                <Icon style={{color: "#fff", fontSize: 38, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>play_circle_filled</Icon>
                                                            </div>
                                                            {this.formatDuration(displayTranslation.duration) && <span style={{position: "absolute", bottom: 6, left: 7, background: "rgba(0,0,0,0.7)", color: "#fff", fontSize: 10, borderRadius: 4, padding: "1px 5px"}}>{this.formatDuration(displayTranslation.duration)}</span>}
                                                        </div>
                                                        {/* Info */}
                                                        <div style={{padding: "8px 10px 4px 10px"}}>
                                                            <span className="d-block font-weight-bold" style={{fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={displayTranslation.title}>{displayTranslation.title}</span>
                                                            <em title={displayTranslation.description} style={{fontSize: 10, color: "#888", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden"}}>{displayTranslation.description}</em>
                                                        </div>
                                                        {/* Actions + Language chips */}
                                                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "auto", padding: "6px 10px 8px 10px", borderTop: "1px solid #f0f0f0"}}>
                                                            <div style={{display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center"}}>
                                                                {(video.VideoTranslations || []).map(t => {
                                                                    const isSelected = t.lang === (video.selectedLang || "en") || (!video.selectedLang && t.lang === displayTranslation.lang);
                                                                    return (
                                                                        <span key={t.lang} className="clickable" style={{fontSize: 9, background: isSelected ? "#1565c0" : "#e3f2fd", color: isSelected ? "#fff" : "#1565c0", borderRadius: 3, padding: "2px 6px", fontWeight: 700, textTransform: "uppercase"}}
                                                                            onClick={() => {
                                                                                let { videoSectionsList } = this.state;
                                                                                videoSectionsList = videoSectionsList.map(s => ({ ...s, Videos: (s.Videos || []).map(v => v.video_id === video.video_id ? {...v, selectedLang: t.lang} : v) }));
                                                                                this.setState({ videoSectionsList });
                                                                            }}>{t.lang}</span>
                                                                    );
                                                                })}
                                                                {video.VideoTranslations.length < 5 && <span className="clickable" title="Add Translation" style={{fontSize: 9, background: "#e8f5e9", color: "#2e7d32", borderRadius: 3, padding: "2px 6px", fontWeight: 700}} onClick={() => this.setState({isAddVideo: {video_id: video.video_id, video_section_id: video.video_section_id, existingLangs: (video.VideoTranslations || []).map(t => t.lang)}})}>+ lang</span>}
                                                            </div>
                                                            <div style={{display: "flex", gap: 6}}>
                                                                <Icon className="clickable" style={{fontSize: 14, color: "#555"}} onClick={() => this.setState({isAddVideo: {...displayTranslation, video_id: video.video_id, video_section_id: video.video_section_id}})}>edit</Icon>
                                                                <Icon className="clickable" style={{fontSize: 14, color: "#e53935"}} onClick={() => this.setState({ isOpenConfirm: () => this.deleteVideo(video, displayTranslation) })}>delete</Icon>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>}
                        </div>
                        )
                    })
                }
                </div>


                <Modal size="lg" isOpen={isAddSection} toggle={()=> {this.setState({isAddSection : false})}} >
                    <ModalHeader toggle={()=> {this.setState({isAddSection : false})}}>Add Video Section</ModalHeader>
                    <ModalBody className="">
                        <form onSubmit={this.addVideoSection}>
                            <Row className="mb-3">
                                <Col style={{marginRight: "-27px"}}>
                                    <Collapse className="card p-3" isOpen={!!isAddSection}>
                                        <Row className="mt-3 align-items-center">
                                            <Col xs={6}><InputFeild   placeholder="Title" value={isAddSection.title || ""} onChange={(e) => { isAddSection.title=e.target.value; this.setState({ isAddSection }) }}/></Col>
                                            <Col xs={6}><InputFeild  placeholder="Description" value={isAddSection.description || ""} onChange={(e) => { isAddSection.description=e.target.value; this.setState({ isAddSection}) }}/></Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col xs={6}>
                                                <SelectList placeholder="Select* " value={isAddSection.entity_type} onChange={(e) => { isAddSection.entity_type=e.target.value; this.setState({ isAddSection}) }} >
                                                    <option value={"APP"}>App Training</option>
                                                    <option value={"GENERIC"}>General Training</option>
                                                    <option value={"JOB_CATEGORY"}>Projects Training</option>
                                                </SelectList>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-right">
                                                <Button className="buttonred m-2 py-2">{isAddSection.video_section_id ? "Update" : "Create"}</Button>
                                                <Button onClick={() => this.setState({isAddSection : false})} className="buttonred m-2 py-2">Cancel</Button>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                </Col>
                            </Row>
                        </form>
                    </ModalBody>
                </Modal>


                        
                <Modal size="lg" isOpen={isAddVideo} toggle={()=> {this.setState({isAddVideo : false})}} >
                    <ModalHeader toggle={()=> {this.setState({isAddVideo : false})}}>
                        {!isAddVideo.video_id ? "Add Video" : isAddVideo.video_translation_id ? `Edit Translation (${(isAddVideo.lang || "").toUpperCase()})` : "Add Translation"}
                    </ModalHeader>
                    <ModalBody className="">
                        {/* Lang selector — only when adding translation to existing video */}
                        {isAddVideo.video_id && !isAddVideo.video_translation_id &&
                        <Row className="mb-3">
                            <Col xs={6}>
                                <SelectList placeholder="Select Language" value={isAddVideo.lang} onChange={(e) => { isAddVideo.lang=e.target.value; this.setState({ isAddVideo }) }}>
                                    {[{value:"en", label:"English"}, {value:"hi", label:"Hindi"}, {value:"ta", label:"Tamil"}, {value:"te", label:"Telugu"}, {value:"kn", label:"Kannada"}]
                                        .filter(l => !(isAddVideo.existingLangs || []).includes(l.value))
                                        .map(l => <option key={l.value} value={l.value}>{l.label}</option>)
                                    }
                                </SelectList>
                            </Col>
                        </Row>}
                        <Row className="mt-3 align-items-center">
                            <Col xs={6}><InputFeild  placeholder="Title" value={isAddVideo.title || ""} onChange={(e) => { isAddVideo.title=e.target.value; this.setState({ isAddVideo }) }}/></Col>
                            <Col xs={6}><InputFeild  placeholder="Description" value={isAddVideo.description || ""} onChange={(e) => { isAddVideo.description=e.target.value; this.setState({ isAddVideo}) }}/></Col>
                        </Row>
                        {/* Entity fields — only for new video */}
                        {!isAddVideo.video_id &&
                        <Row className="mt-3">
                            <Col xs={6}>
                                <SelectList placeholder="Select" value={isAddVideo.entity_type} onChange={(e) => { isAddVideo.entity_type=e.target.value; this.setState({ isAddVideo}) }} >
                                    <option value={"APP"}>App Training</option>
                                    <option value={"GENERIC"}>General Training</option>
                                    <option value={"JOB"}>Projects Training</option>
                                </SelectList>
                            </Col>
                            {isAddVideo.entity_type === "JOB" &&
                            <Col xs={6}>
                                <SelectList search={true} placeholder="Select Project" value={isAddVideo.entity_id} onChange={(e) => { isAddVideo.entity_id=e.target.value; this.setState({ isAddVideo}) }} >
                                    {
                                        jobList.map(job =>
                                        <option key={job.job_id} value={job.job_id}>
                                            {job.Employer.employer_name +  "  -  "  + job.title}
                                            {job.archive_status !== 0 && <Chip size="small" style={{fontSize: 8}} className="ml-3" label={CONSTANTS.ARCHIVE_STATUS_TEXT[job.archive_status]} /> }
                                        </option>
                                    )}
                                </SelectList>
                            </Col>}
                        </Row>}
                        <Row className="mt-3 align-items-center" style={{justifyContent: "space-around"}}>
                            <Col xs={4}>
                                <ImageUploadFeild required className="my-2 text-center" label="Add Thumbnail" src={isAddVideo.thumbnail_url} onChange={(file) => {isAddVideo.thumbnail_file = file; this.setState({isAddVideo})}} />
                            </Col>
                            <Col xs={4} >
                                <VideoUploadFeild id="video_upload_input_training" label={"Add Video"} src={isAddVideo.video_url} onChange={(file) => {isAddVideo.video_file = file; this.setState({isAddVideo})}} onLoadedMetadata={this.getVideoFileMeta} />
                            </Col>
                        </Row>
                        
                        <Row className="mt-3 border-top py-2">
                            <Col className="text-right">
                                <Button onClick={() => this.addVideo()} className="buttonred m-2 py-2">Save</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>


                <ConfirmAction isOpen={!!this.state.isOpenConfirm} callback={this.state.isOpenConfirm} onClose={() => this.setState({isOpenConfirm : false, confirmMessage : null})} />
         
            </>
        )}};
    
    export default ManageAppVideos;




   

